import Icon, {
  CustomIconComponentProps,
} from '@ant-design/icons/lib/components/Icon';

const SvgDefaults = {
  focusable: false,
  viewBox: '0 0 200 200',
  fill: 'currentColor',
  width: '1em',
  height: '1em',
};
/**
 * Icone Personalizzate SVG
 *
 */
export const CiAlignJustify = (props: Partial<CustomIconComponentProps>) => (
  <Icon
    component={() => (
      <svg {...SvgDefaults} pointerEvents={'none'}>
        <rect x="12" y="22.12" width="176" height="15.84" rx="1.56" ry="1.56" />
        <path d="M13.56,68.76h172.88c.86,0,1.56.7,1.56,1.56v12.72c0,.86-.7,1.56-1.56,1.56H13.56c-.86,0-1.56-.7-1.56-1.56v-12.72c0-.86.7-1.56,1.56-1.56Z" />
        <path d="M13.56,115.4h172.88c.86,0,1.56.7,1.56,1.56v12.72c0,.86-.7,1.56-1.56,1.56H13.56c-.86,0-1.56-.7-1.56-1.56v-12.72c0-.86.7-1.56,1.56-1.56Z" />
        <path d="M13.56,162.04h109.51c.86,0,1.56.7,1.56,1.56v12.72c0,.86-.7,1.56-1.56,1.56H13.56c-.86,0-1.56-.7-1.56-1.56v-12.72c0-.86.7-1.56,1.56-1.56Z" />
      </svg>
    )}
    {...props}
  />
);
